import type { FactoriesTranslations } from './types';

/**
 * English translations for Factories domain
 */
export const enTranslations: FactoriesTranslations = {
  // Page/Section level
  title: 'Factories',
  subtitle: 'Manage manufacturing plants and production facilities',

  // Actions
  addFactory: 'Add Factory',
  editFactory: 'Edit Factory',
  deleteFactory: 'Delete Factory',
  factoryDetails: 'Factory Details',

  // Search and states
  searchPlaceholder: 'Search factories...',
  filterByStatus: 'Filter by status',
  noFactories: 'No Factories Found',
  noFactoriesDescription:
    "You haven't added any factories yet. Add your first factory to get started.",
  addFirst: 'Add Your First Factory',
  totalFactories: 'Total Factories',

  // Form fields
  form: {
    factory: 'Factory',
    selectFactory: 'Select factory',
    code: 'Factory Code',
    codePlaceholder: 'Enter factory code (e.g., FAC-001)',
    sapPlantCode: 'SAP Plant Code',
    sapPlantCodePlaceholder: 'Enter SAP plant code (e.g., 1000)',
    nameEn: 'Factory Name (English)',
    nameEnPlaceholder: 'Enter factory name in English',
    nameAr: 'Factory Name (Arabic)',
    nameArPlaceholder: 'Enter factory name in Arabic',
    address: 'Address',
    addressPlaceholder: 'Enter street address',
    city: 'City',
    selectCity: 'Select city',
    country: 'Country',
    selectCountry: 'Select country',
    postalCode: 'Postal Code',
    timezone: 'Timezone',
    coordinates: 'Coordinates',
    status: 'Status',
  },

  // Validation
  validation: {
    codeRequired: 'Factory code is required',
    nameRequired: 'Factory name is required',
    countryRequired: 'Country is required',
  },

  // Status
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },

  // Messages
  messages: {
    createSuccess: 'Factory created successfully',
    updateSuccess: 'Factory updated successfully',
    deleteSuccess: 'Factory deleted successfully',
    deleteConfirm: 'Are you sure you want to delete this factory?',
  },

  // Card display
  card: {
    noAddress: 'No address',
    noCity: 'No city',
    noCountry: 'No country',
    locationNotSet: 'Location not set',
    created: 'Created',
    updated: 'Updated',
  },

  // Top-level convenience keys (flat versions for direct access)
  code: 'Factory Code',
  codePlaceholder: 'Enter factory code (e.g., FAC-001)',
  sapPlantCode: 'SAP Plant Code',
  sapPlantCodePlaceholder: 'Enter SAP plant code (e.g., 1000)',
  nameEn: 'Factory Name (English)',
  nameEnPlaceholder: 'Enter factory name in English',
  nameAr: 'Factory Name (Arabic)',
  nameArPlaceholder: 'Enter factory name in Arabic',
  address: 'Address',
  addressPlaceholder: 'Enter street address',
  city: 'City',
  selectCity: 'Select city',
  country: 'Country',
  selectCountry: 'Select country',
  postalCode: 'Postal Code',
  timezone: 'Timezone',
  coordinates: 'Coordinates',
  statusLabel: 'Status',
  codeRequired: 'Factory code is required',
  nameRequired: 'Factory name is required',
  countryRequired: 'Country is required',
  active: 'Active',
  inactive: 'Inactive',
  createSuccess: 'Factory created successfully',
  updateSuccess: 'Factory updated successfully',
  deleteSuccess: 'Factory deleted successfully',
  deleteConfirm: 'Are you sure you want to delete this factory?',
  noAddress: 'No address',
  noCity: 'No city',
  noCountry: 'No country',
  locationNotSet: 'Location not set',
  created: 'Created',
  updated: 'Updated',
  addDescription: 'Add a new manufacturing facility',
  editDescription: 'Update factory details',
  basicInfo: 'Basic Information',
  selectStatus: 'Select status',
  locationInfo: 'Location',
  selectLocation: 'Select location',
  noLocationOption: 'None',
  locationHint: 'Select an existing location from the address book or leave empty',
  citiesServed: 'Cities Served',
  citiesServedHint: 'Select the cities this factory can deliver to',
  searchCities: 'Search cities...',
  noCitiesMatch: 'No cities match your search',
  noCitiesAvailable: 'No cities available',
  selectedCityCount: '{{count}} cities selected',
  selected: 'Selected',
  loadMoreCities: 'Load more cities',
  descriptionSection: 'Description',
  descriptionEn: 'Description (English)',
  descriptionAr: 'Description (Arabic)',
  descriptionPlaceholder: 'Enter factory description',
  descriptionArPlaceholder: 'Enter factory description in Arabic',
  saving: 'Saving...',
  deleting: 'Deleting...',
  close: 'Close',
};
